module.exports = __webpack_public_path__ + "static/media/Sass.ba1b42e8.png";